var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Card",
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c("div", { staticClass: "left-bar" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("抛头/赠送率设置"),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { staticStyle: { margin: "10px" }, attrs: { gutter: 16 } },
            [
              _c(
                "Form",
                { attrs: { "label-position": "top" } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "抛头/赠送率(百分比,如10为10%)" } },
                        [
                          _c("InputNumber", {
                            staticStyle: { width: "100%" },
                            attrs: { min: 0, max: 100, "active-change": false },
                            model: {
                              value: _vm.seedFarm.additionalRate,
                              callback: function ($$v) {
                                _vm.$set(_vm.seedFarm, "additionalRate", $$v)
                              },
                              expression: "seedFarm.additionalRate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { staticStyle: { margin: "10px" }, attrs: { gutter: 16 } },
            [
              _c(
                "Form",
                { attrs: { "label-position": "top" } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        [
                          _c(
                            "Button",
                            {
                              attrs: { type: "success" },
                              on: {
                                click: function ($event) {
                                  return _vm.saveSeedFarm()
                                },
                              },
                            },
                            [_vm._v("保存")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }